export const BIT_SUPPORT_OPTIONS = ['32位', '64位', '32/64位'];

export const GUIDE_FIELD_GROUPS = [
  {
    key: 'software',
    title: '配置信息',
    fields: [
      { key: 'softwarePackage', label: '软件包', control: 'input', copyable: false },
      { key: 'openSystems', label: '开放系统及功能', control: 'input', copyable: false },
      {
        key: 'bitSupport',
        label: '系统架构',
        control: 'select',
        copyable: false,
        options: BIT_SUPPORT_OPTIONS,
        placeholder: '请选择系统架构',
      },
    ],
  },
  {
    key: 'logs',
    title: '路径信息',
    fields: [
      { key: 'storagePath', label: '烧号路径', control: 'input', copyable: true },
      { key: 'diagLogUploadPath', label: '诊断日志上传路径', control: 'input', copyable: true },
      { key: 'apkLogUploadPath', label: 'APK日志上传路径', control: 'input', copyable: true },
      { key: 'diagLogStoragePath', label: '诊断日志存放路径', control: 'input', copyable: true },
    ],
  },
  {
    key: 'usage',
    title: '补充信息',
    fields: [
      { key: 'testNotes', label: '测试注意事项', control: 'textarea', copyable: false },
    ],
  },
];

export const GUIDE_FIELD_DEFS = GUIDE_FIELD_GROUPS.flatMap((group) => group.fields);

const emptyFields = () => Object.fromEntries(GUIDE_FIELD_DEFS.map((field) => [field.key, '']));

function createMeta(editor, time) {
  return { lastEditor: editor, lastEditedAt: time };
}

function createFieldState(value, editor, time) {
  return { value, ...createMeta(editor, time) };
}

function cloneFields(fields) {
  return Object.fromEntries(
    Object.entries(fields).map(([key, item]) => [key, { ...item }]),
  );
}

function cloneCustomFields(list = []) {
  return list.map((item) => ({ ...item }));
}

function buildProduct({ id, name, prefix, category, fields, history, customFields = [] }) {
  return {
    id,
    name,
    prefix,
    category,
    fields: cloneFields(fields),
    customFields: cloneCustomFields(customFields),
    history: history.map((item) => ({ ...item })),
  };
}

const maxFlexFields = {
  softwarePackage: createFieldState('PRO', '张三', '2026-08-20 09:12'),
  storagePath: createFieldState('cnlaunch\\MaxFlex\\DIAGNOSTIC\\VEHICLES', '张三', '2026-08-29 11:20'),
  openSystems: createFieldState('全系统 + 全功能', '李四', '2026-08-21 14:08'),
  bitSupport: createFieldState('32/64位', '王五', '2026-08-22 10:40'),
  diagLogUploadPath: createFieldState('/sdcard/diag/log/upload', '张三', '2026-08-23 15:02'),
  apkLogUploadPath: createFieldState('/sdcard/apk/log/upload', '李四', '2026-08-23 15:18'),
  diagLogStoragePath: createFieldState('/sdcard/diag/log/', '张三', '2026-08-23 15:30'),
  setupMethod: createFieldState(
    '1. 进入诊断首页\n2. 右上角设置\n3. 进入设备信息\n4. 长按 SN 区域5秒进入工程模式',
    '王五',
    '2026-08-24 09:55',
  ),
  testNotes: createFieldState(
    '1. 使用稳定电源供电\n2. 测试前备份日志\n3. 断开网络可避免自动升级',
    '李四',
    '2026-08-28 16:35',
  ),
};

const maxFlexProFields = {
  softwarePackage: createFieldState('PRO', '李四', '2026-08-18 11:00'),
  storagePath: createFieldState('cnlaunch\\MaxFlexPro\\DIAGNOSTIC\\VEHICLES', '李四', '2026-08-19 13:22'),
  openSystems: createFieldState('全系统', '张三', '2026-08-19 16:40'),
  bitSupport: createFieldState('', '', ''),
  diagLogUploadPath: createFieldState('/sdcard/diag/log/upload', '王五', '2026-08-20 09:10'),
  apkLogUploadPath: createFieldState('', '', ''),
  diagLogStoragePath: createFieldState('/sdcard/diag/log/', '王五', '2026-08-20 09:12'),
  setupMethod: createFieldState('进入诊断首页后，长按版本号进入工程模式。', '赵六', '2026-08-21 08:44'),
  testNotes: createFieldState('', '', ''),
};

const maxFlexIntlFields = {
  softwarePackage: createFieldState('INTL', '陈七', '2026-08-12 10:21'),
  storagePath: createFieldState('cnlaunch\\MaxFlexIntl\\DIAGNOSTIC\\VEHICLES', '陈七', '2026-08-12 10:40'),
  openSystems: createFieldState('', '', ''),
  bitSupport: createFieldState('32/64位', '李四', '2026-08-15 17:05'),
  diagLogUploadPath: createFieldState('', '', ''),
  apkLogUploadPath: createFieldState('', '', ''),
  diagLogStoragePath: createFieldState('/sdcard/diag/log/', '张三', '2026-08-16 09:18'),
  setupMethod: createFieldState('', '', ''),
  testNotes: createFieldState('测试前确认地区固件与语言包。', '王五', '2026-08-16 11:02'),
};

const padEliteFields = {
  softwarePackage: createFieldState('PAD', '张三', '2026-08-10 08:30'),
  storagePath: createFieldState('cnlaunch\\PADElite\\DIAGNOSTIC\\VEHICLES', '张三', '2026-08-10 08:40'),
  openSystems: createFieldState('发动机 / 变速箱 / 车身', '李四', '2026-08-11 09:16'),
  bitSupport: createFieldState('', '', ''),
  diagLogUploadPath: createFieldState('/sdcard/diag/log/upload', '张三', '2026-08-11 10:02'),
  apkLogUploadPath: createFieldState('/sdcard/apk/log/upload', '张三', '2026-08-11 10:03'),
  diagLogStoragePath: createFieldState('/sdcard/diag/log/', '张三', '2026-08-11 10:04'),
  setupMethod: createFieldState('进入设置 → 关于本机 → 连续点击版本号。', '王五', '2026-08-12 14:20'),
  testNotes: createFieldState('仅用于 PAD 系列摸底，勿用于量产刷写。', '李四', '2026-08-13 16:08'),
};

const products = [
  buildProduct({
    id: 'maxflex',
    name: 'MaxFlex',
    prefix: '98971',
    category: 'DIY产品',
    fields: maxFlexFields,
    history: [
      { editor: '张三', fieldLabel: '烧号路径', time: '2026-08-29 11:20' },
      { editor: '李四', fieldLabel: '测试注意事项', time: '2026-08-28 16:35' },
    ],
  }),
  buildProduct({
    id: 'maxflex-pro',
    name: 'MaxFlex Pro',
    prefix: '98971',
    category: 'DIY产品',
    fields: maxFlexProFields,
    history: [
      { editor: '李四', fieldLabel: '烧号路径', time: '2026-08-19 13:22' },
    ],
  }),
  buildProduct({
    id: 'maxflex-intl',
    name: 'MaxFlex International',
    prefix: '98971',
    category: 'DIY产品',
    fields: maxFlexIntlFields,
    history: [
      { editor: '陈七', fieldLabel: '软件包', time: '2026-08-12 10:21' },
    ],
  }),
  buildProduct({
    id: 'pad-elite',
    name: 'PAD Elite',
    prefix: '98654',
    category: 'PAD系列',
    fields: padEliteFields,
    history: [
      { editor: '张三', fieldLabel: '软件包', time: '2026-08-10 08:30' },
    ],
  }),
];

const categories = ['DIY产品', 'PAD系列', 'MATCO系列', '未分类'];

const leaderboard = {
  ranking: [
    { rank: 1, name: '张三', score: 125, avatar: '' },
    { rank: 2, name: '李四', score: 98, avatar: '' },
    { rank: 3, name: '王五', score: 72, avatar: '' },
    { rank: 4, name: '赵六', score: 58, avatar: '' },
    { rank: 5, name: '陈七', score: 41, avatar: '' },
  ],
  mine: { rank: 6, score: 32, avatar: '' },
};

export const QUERY_EXAMPLE_PREFIX = '98971';
export const QUERY_DELAY_MS = 280;

export const GUIDE_GROUP_OPTIONS = GUIDE_FIELD_GROUPS.map((group) => ({
  value: group.key,
  label: group.title,
}));

const CUSTOM_FIELD_TYPE = 'text';

let customFieldSeq = 1;

export function normalizeGuidePrefix(value) {
  return String(value || '').trim().slice(0, 5);
}

export function isCompleteGuidePrefix(value) {
  return normalizeGuidePrefix(value).length === 5;
}

export function getGuideFieldDef(fieldKey) {
  return GUIDE_FIELD_DEFS.find((item) => item.key === fieldKey) || null;
}

export function normalizeGuideSelectValue(field, value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '';
  }

  const options = field?.options || [];
  if (!options.length || options.includes(raw)) {
    return raw;
  }

  const compact = raw.replace(/\s+/g, '');
  const matched = options.find((option) => {
    const optionCompact = String(option).replace(/\s+/g, '');
    return optionCompact === compact
      || optionCompact.replace(/位/g, '') === compact.replace(/位/g, '');
  });
  return matched || raw;
}

export function countFilledGuideFields(product) {
  return GUIDE_FIELD_DEFS.filter((field) => String(product?.fields?.[field.key]?.value || '').trim()).length;
}

export function getGuideCompleteness(product) {
  const total = GUIDE_FIELD_DEFS.length;
  const filled = countFilledGuideFields(product);
  return {
    filled,
    total,
    percent: total === 0 ? 0 : Math.round((filled / total) * 100),
  };
}

function publicProduct(product) {
  return {
    id: product.id,
    name: product.name,
    prefix: product.prefix,
    category: product.category,
    fields: cloneFields(product.fields),
    customFields: cloneCustomFields(product.customFields),
    history: product.history.map((item) => ({ ...item })),
  };
}

export function queryGuidesByPrefix(prefix) {
  const normalized = normalizeGuidePrefix(prefix);
  if (normalized.length !== 5) {
    return { status: 'invalid', matches: [] };
  }

  const matches = products
    .filter((item) => item.prefix === normalized)
    .map((item) => publicProduct(item));

  if (matches.length === 0) {
    return { status: 'empty', matches };
  }
  if (matches.length === 1) {
    return { status: 'unique', matches };
  }
  return { status: 'multiple', matches };
}

export function getGuideProductById(id) {
  const product = products.find((item) => item.id === id);
  return product ? publicProduct(product) : null;
}

export function getGuideCategories() {
  return [...categories];
}

export function getGuideLeaderboard() {
  return {
    ranking: leaderboard.ranking.map((item) => ({ ...item })),
    mine: { ...leaderboard.mine },
  };
}

function nowStamp() {
  const date = new Date();
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function saveGuideField({ productId, fieldKey, value, editor }) {
  const product = products.find((item) => item.id === productId);
  if (!product) {
    return null;
  }

  const fieldDef = getGuideFieldDef(fieldKey);
  const nextValue = fieldDef?.control === 'select'
    ? normalizeGuideSelectValue(fieldDef, value)
    : String(value || '');
  const stamp = nowStamp();

  if (fieldDef) {
    product.fields[fieldKey] = createFieldState(nextValue, editor, stamp);
    product.history.unshift({
      editor,
      fieldLabel: fieldDef.label,
      time: stamp,
    });
    return publicProduct(product);
  }

  const custom = product.customFields.find((item) => item.id === fieldKey);
  if (!custom) {
    return null;
  }

  custom.value = nextValue;
  custom.lastEditor = editor;
  custom.lastEditedAt = stamp;
  product.history.unshift({
    editor,
    fieldLabel: custom.label,
    time: stamp,
  });

  return publicProduct(product);
}

export function addCustomGuideField({ productId, group, label, value, editor }) {
  const product = products.find((item) => item.id === productId);
  const nextLabel = String(label || '').trim();
  const nextGroup = String(group || '').trim();

  if (!product || !nextLabel || !GUIDE_GROUP_OPTIONS.some((item) => item.value === nextGroup)) {
    return null;
  }

  const stamp = nowStamp();
  product.customFields.push({
    id: `custom-${customFieldSeq}`,
    label: nextLabel,
    type: CUSTOM_FIELD_TYPE,
    value: String(value || ''),
    group: nextGroup,
    custom: true,
    lastEditor: editor,
    lastEditedAt: stamp,
  });
  customFieldSeq += 1;
  product.history.unshift({
    editor,
    fieldLabel: nextLabel,
    time: stamp,
  });

  return publicProduct(product);
}

export function deleteCustomGuideField({ productId, fieldId, editor }) {
  const product = products.find((item) => item.id === productId);
  if (!product) {
    return null;
  }

  const index = product.customFields.findIndex((item) => item.id === fieldId);
  if (index < 0) {
    return null;
  }

  const removed = product.customFields.splice(index, 1)[0];
  product.history.unshift({
    editor,
    fieldLabel: removed.label,
    time: nowStamp(),
  });

  return publicProduct(product);
}

export function saveGuideCategory({ productId, category }) {
  const product = products.find((item) => item.id === productId);
  const nextCategory = String(category || '').trim();
  if (!product || !nextCategory) {
    return null;
  }

  product.category = nextCategory;
  if (!categories.includes(nextCategory)) {
    categories.push(nextCategory);
  }

  return publicProduct(product);
}

export function addGuideCategory(name) {
  const nextName = String(name || '').trim();
  if (!nextName) {
    return getGuideCategories();
  }
  if (!categories.includes(nextName)) {
    categories.push(nextName);
  }
  return getGuideCategories();
}

export function createEmptyGuideFields() {
  return emptyFields();
}
